/* eslint-disable no-sequences */
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useNavigate, useLocation } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import {
  checkToken,
  payerInformation,
  findMemberByMobileNumber,
  transactionsCollection,
  addMomoPayment,
  paymentTransactionsByPhone,
  getLedgerMobile_number,
} from "../../../api/apiServices";
import generateTransactionId from "../../../services/generateTransactionId";
import Loader from "../../Common/Spinner/Loader";
import getServiceProvider from "../../../services/getServiceProvider";

const languageId = `${process.env.REACT_APP_LANGUAGE_ID}`;
const countryCode = `${process.env.REACT_APP_COUNTRY_CODE}`;
const transCurrencyIso = `${process.env.REACT_APP_TRANS_CURRENCY_ISO}`;

const AdmissionFees = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const [canSubmit, setCanSubmit] = useState(false);
  const [isFinalStepOK, setIsFinalStepOK] = useState(false);
  const [isMoMo, setIsMoMo] = useState(false);
  const [isMakePayment, setIsMakePayment] = useState(false);
  const [isNameFound, setIsNameFound] = useState(false);
  const [member_payments, setMemberPayments] = useState([]);
  const [findMember, setFindMember] = useState(false);
  const [member_ledger, setMemberLedger] = useState([]);
  const [payment_year, setPaymentYear] = useState("");
  const [payment_mode, setPaymentMode] = useState("");
  const [pf_number, setPFNumber] = useState("");
  const [mobile_number, setMobileNumber] = useState("");
  const [fullname, setFullname] = useState();
  const [amount, setAmount] = useState("");
  const [payPartnerServiceId, setPayPartnerServiceId] = useState("");
  const [transaction_id, setTransactionId] = useState("");

  const [isPayWithAnotherNumber, setIsPayWithAnotherNumber] = useState(false);
  const [pay_with_another_number, setPayWithAnotherNumber] = useState("");

  const [another_phone_number, setAnotherPhoneNumber] = useState("");
  const [anotherPhoneNumberFullname, setAnotherPhoneNumberFullname] =
    useState("");

  const payment_type = "MP";

  useEffect(() => {
    mobile_number &&
      paymentTransactionsByPhone(mobile_number).then((res) => {
        setMemberPayments(res);
      });

    const verifyToken = async () => {
      checkToken();
    };
    verifyToken();
  }, [mobile_number]);

  const handleSearchMember = () => {
    if (!mobile_number || mobile_number === "233") {
      toast.error("Please enter your registered phone number", {
        duration: 5000,
        className: "toast-message",
      });
      return false;
    } else {
      mobile_number &&
        findMemberByMobileNumber(mobile_number).then((res) => {
          if (!res.success) {
            toast.error(res.message, {
              duration: 5000,
              className: "toast-message",
            });
            return false;
          }
          if (res.hasPFNumber) {
            toast.error(
              "The phone number belongs to an existing member. Choose Yearly Dues to make the payment",
              {
                duration: 5000,
                className: "toast-message",
              }
            );
            setMobileNumber("233");
            return false;
          }
          setFullname(
            res?.member?.first_name.trim() +
              " " +
              res?.member?.middle_name.trim() +
              " " +
              res?.member?.last_name.trim()
          );
          setFindMember(true);
          getLedgerMobile_number(res.member?.mobile_number).then((res) => {
            setMemberLedger(res);
          });
        });
      generateTransactionId().then((result) => {
        setTransactionId(result);
      });
    }
  };

  let transactionDate = [];
  let transactionYear = [];
  for (var i = 0; i < member_ledger?.length; i++) {
    transactionDate.push(new Date([member_ledger[i].transaction_date]));
    transactionYear.push(member_ledger[i].year);
  }

  transactionDate.sort((a, b) => a - b);
  transactionYear.sort((a, b) => a - b);

  let maxTDate = transactionDate[transactionDate.length - 1];
  let maxYear = transactionYear[transactionYear.length - 1];

  // console.log("Max date:", maxTDate.toISOString().split('T')[0]);

  const lastYear = member_ledger?.filter(
    (item) =>
      new Date(item.transaction_date).toISOString().split("T")[0] ===
      maxTDate.toISOString().split("T")[0]
  );

  let maxClosingBalance = Math.max(lastYear[0]?.closing_balance);

  const handleMobileNumberInput = (value, countryObj, e, formattedValue) => {
    const name = e.target.name;

    let mobileNumber = value.replaceAll(" ", "");

    if (mobileNumber.substring(4, 0) === "2330") {
      mobileNumber = mobileNumber.replace("0", "");
    }

    if (name === "another_phone_number") {
      setAnotherPhoneNumber(mobileNumber);
    } else {
      setMobileNumber(mobileNumber.replaceAll(" ", ""));
    }
  };

  const handlePayWithAnotherNumber = (e) => {
    const anotherNumber = e.target.value;

    setPayWithAnotherNumber(anotherNumber);
    if (anotherNumber === "YES") {
      setCanSubmit(false);
      setIsPayWithAnotherNumber(true);
      setPaymentMode("M");
      setIsMoMo(true);
    } else {
      getServiceProvider(mobile_number).then((result) => {
        setPayPartnerServiceId(result);
      });
      setIsFinalStepOK(true);
      setIsPayWithAnotherNumber(false);
      setPaymentMode("M");
      setIsMoMo(true);
      setCanSubmit(true);
    }
  };

  const handleAccountInfo = async (e) => {
    const value = another_phone_number;
    let mobileNumber = "";
    if (value === "") {
      toast.error("Please enter your mobile number", {
        duration: 5000,
        className: "toast-message",
      });
      return false;
    } else if (value === "+233") {
      toast.error(
        "The mobile number is not valid. Please provide a valid mobile number to continue",
        {
          duration: 5000,
          className: "toast-message",
        }
      );
      return false;
    }

    if (value.substring(5, 0) === "+2330") {
      mobileNumber = value.replace("0", "");
    } else {
      mobileNumber = value;
    }
    mobileNumber = mobileNumber.replace("+", "");

    let serviceProvider = "";
    await getServiceProvider(mobileNumber).then((result) => {
      serviceProvider = result;
      setPayPartnerServiceId(result);
    });
    const infoData = {
      paypartnerCode: serviceProvider,
      accountNoOrCardNoOrMSISDN: mobileNumber,
      languageId: languageId,
      countryCode: countryCode,
    };
    getMemberInfoMutation.mutate(infoData);
  };

  const getMemberInfoMutation = useMutation(payerInformation, {
    onSuccess: async (res) => {
      if (!res.data.isSuccess) {
        toast.error("Phone number is not valid", {
          duration: 5000,
          className: "toast-message",
        });
        return false;
      } else {
        generateTransactionId().then((result) => {
          setTransactionId(result);
        });
        if (!isPayWithAnotherNumber) {
          setFullname(res.data.accountName);
          return true;
        } else {
          setIsFinalStepOK(true);
          setIsNameFound(true);
          setAnotherPhoneNumberFullname(res.data.accountName);
          setCanSubmit(true);
          return true;
        }
      }
    },
    onError: async (err) => {
      toast.error(err.message, {
        duration: 5000,
        className: "toast-message",
      });
      return false;
    },
  });

  const handleOnlinePayment = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const momoPaymentData = {
      paypartnerCode: payPartnerServiceId,
      amount: amount,
      accountNoOrCardNoOrMSISDN: !isPayWithAnotherNumber
        ? mobile_number
        : another_phone_number,
      accountName: fullname.toLocaleUpperCase(),
      transactionId: transaction_id,
      narration: "PF Payment",
      transCurrencyIso: transCurrencyIso,
      expiryDateMonth: 0,
      expiryDateYear: 0,
      cvv: "",
      languageId: languageId,
      callback: `${process.env.REACT_APP_CALLBACK}/${transaction_id}`,
    };
    transactionsCollectionMutation.mutate(momoPaymentData);
  };

  const transactionsCollectionMutation = useMutation(transactionsCollection, {
    onSuccess: async (res) => {
     if (res.data.result.transactionStatus === "PENDING") {
       const clearanceData = {
         PayPartnerServiceId: payPartnerServiceId,
         amount: parseFloat(amount).toFixed(2),
         mobile_number: mobile_number,
         fullname: fullname.toLocaleUpperCase(),
         payment_year: payment_year,
         payment_type: payment_type.toLocaleUpperCase(),
         payment_mode: payment_mode.toLocaleUpperCase(),
         pf_number: pf_number.toLocaleUpperCase(),
         transaction_id: res.data.transaction_id,
       };
       addMomoMutation.mutate(clearanceData);
     } else {
       toast.error(res.data.message, {
         duration: 5000,
         className: "toast-message",
       });
       setIsLoading(false);
       setIsMoMo(false);
       navigate(from, { replace: true });
     }
    },
    onError: async (err) => {
      toast.error(err.message, {
        duration: 5000,
        className: "toast-message",
      });
      setIsLoading(false);
      setIsMoMo(false);
      navigate(from, { replace: true });
    },
  });

  const addMomoMutation = useMutation(addMomoPayment, {
    onSuccess: async (res) => {
      if (res.success === true) {
        toast.success(res.message, {
          duration: 5000,
          className: "toast-message",
        });
        setIsLoading(false);
        setIsMoMo(false);
        setPaymentYear("");
        setPFNumber("");
        setMobileNumber("233");
        setFullname("");
        setAmount("");
        setIsMakePayment(false);
        setFindMember(false);
      } else {
        toast.success(res.message, {
          duration: 5000,
          className: "toast-message",
        });
        setIsLoading(false);
        setIsMoMo(false);
        setPaymentYear("");
        setPFNumber("");
        setMobileNumber("233");
        setFullname("");
        setAmount("");
        setFindMember(false);
        // navigate(from, { replace: true });
      }
    },
    onError: async (err) => {
      toast.error(err.message, {
        duration: 5000,
        className: "toast-message",
      });
      setIsLoading(false);
      setIsMoMo(false);
      setPaymentYear("");
      setPFNumber("");
      setMobileNumber("233");
      setFullname("");
      setAmount("");
      setFindMember(false);
      //   navigate(from, { replace: true });
    },
  });

  const handleCancel = () => {
    setPaymentYear("");
    setPFNumber("");
    setMobileNumber("233");
    setFullname("");
    setAmount("");
    setIsMakePayment(false);
    setFindMember(false);
  };

  const handleExit = () => {
    navigate(from, { replace: true });
  };

  const handleMakePayment = (year, balance) => {
    setPaymentYear(year);
    setAmount(balance * -1);
    setIsMakePayment(true);
  };

  const handleAlreadyPaid = () => {
    toast.error("You have already paid for this year's dues", {
      duration: 5000,
      className: "toast-message",
    });
    return false;
  };

  const memberLedger = (
    <>
      <div className="wrapper-container">
        <legend>DUES PAYMENT TRANSACTIONS</legend>
        <div className="table-responsive lg">
          <table className="table table-borderless table-hover table-striped">
            <thead>
              <tr>
                <th style={{ textAlign: "center" }}>Year</th>
                <th
                  style={{
                    textAlign: "right",
                    whiteSpace: "nowrap",
                  }}
                >
                  Expected Dues
                </th>
                <th
                  style={{
                    textAlign: "right",
                    whiteSpace: "nowrap",
                  }}
                >
                  Amount Paid
                </th>
                <th
                  style={{
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  Payment Date
                </th>
                <th
                  style={{
                    textAlign: "right",
                    whiteSpace: "nowrap",
                  }}
                >
                  Closing Balance{" "}
                </th>
                <th style={{ textAlign: "center" }}>Action </th>
              </tr>
            </thead>
            <tbody>
              {member_ledger.map((ledger) => (
                <>
                  <tr key={ledger?.id}>
                    <td style={{ textAlign: "center" }}>{ledger?.year}</td>
                    {ledger?.expected_total_amount < 0 ? (
                      <td style={{ textAlign: "right" }}>
                        (
                        {(ledger?.expected_total_amount * -1).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                          }
                        )}
                        ){" "}
                      </td>
                    ) : (
                      <td style={{ textAlign: "right" }}>
                        {ledger?.expected_total_amount.toLocaleString(
                          undefined,
                          { minimumFractionDigits: 2 }
                        )}{" "}
                      </td>
                    )}
                    <td style={{ textAlign: "right" }}>
                      {ledger?.total_amount_paid.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })}{" "}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {ledger?.transaction_date}
                    </td>
                    {ledger?.closing_balance < 0 ? (
                      <td style={{ textAlign: "right" }}>
                        (
                        {(ledger?.expected_total_amount * -1).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                          }
                        )}
                        ){" "}
                      </td>
                    ) : (
                      <td style={{ textAlign: "right" }}>
                        {ledger?.closing_balance.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })}{" "}
                      </td>
                    )}
                    {ledger?.closing_balance < 0 ? (
                      <td
                        style={{
                          whiteSpace: "nowrap",
                          textAlign: "center",
                        }}
                      >
                        <button
                          type="button"
                          style={{
                            width: "150px",
                            fontSize: "16px",
                            padding: "5px 10px",
                            borderRadius: "5px",
                            backgroundColor: "brown",
                            color: "#fff",
                            fontWeight: "bold",
                          }}
                          onClick={() =>
                            handleMakePayment(
                              ledger?.year,
                              ledger.expected_total_amount
                            )
                          }
                          className="btn "
                        >
                          <i className="fa fa-money"></i> Pay Dues
                        </button>
                      </td>
                    ) : (
                      <td
                        style={{
                          whiteSpace: "nowrap",
                          textAlign: "center",
                        }}
                      >
                        <button
                          type="button"
                          style={{
                            width: "150px",
                            fontSize: "16px",
                            padding: "5px 10px",
                            borderRadius: "5px",
                            color: "#fff",
                            fontWeight: "bold",
                          }}
                          onClick={handleAlreadyPaid}
                          // disabled
                          className="btn btn-success"
                        >
                          <i className="fa fa-check"></i> PAID
                        </button>
                      </td>
                    )}
                  </tr>
                </>
              ))}
            </tbody>
            <tfoot>
              <tr>
                {maxClosingBalance < 0 ? (
                  <td
                    colSpan="7"
                    style={{
                      width: "150px",
                      textAlign: "center",
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "darkred",
                    }}
                  >
                    <h4>
                      Click on <strong>"Pay Dues"</strong> to pay for specific
                      year dues
                    </h4>
                  </td>
                ) : (
                  <td
                    colSpan="7"
                    style={{
                      width: "55%",
                      textAlign: "center",
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "var(--main-color)",
                    }}
                  >
                    No dues or arrears to pay. Thank you
                  </td>
                )}
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </>
  );

  const mobileMoneyPayment = (
    <>
      {!isPayWithAnotherNumber ? (
        <>
          <label htmlFor="payment_year" className="col-sm-5 col-form-label">
            Payment Year<span>&nbsp;&nbsp;*</span>
          </label>
          <div className="col-sm-7">
            <input
              type="text"
              name="payment_year"
              id="payment_year"
              style={{
                height: "40px",
                textTransform: "uppercase",
              }}
              disabled
              value={payment_year}
              className="form-control"
            />
          </div>
          <label htmlFor="amount" className="col-sm-5 col-form-label">
            Amount<span>&nbsp;&nbsp;*</span>
          </label>
          <div className="col-sm-7">
            <input
              type="number"
              name="amount"
              id="amount"
              style={{
                height: "40px",
                textTransform: "uppercase",
              }}
              placeholder="Amount"
              required
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="form-control"
            />
            <span>An additional fee may apply to this payment</span>
          </div>
        </>
      ) : (
        <>
          <label htmlFor="another_phone_number" className="col-sm-4">
            Enter Phone Number<span>&nbsp;&nbsp;*</span>
          </label>
          <div className="col-sm-6">
            <PhoneInput
              id="another_phone_number"
              inputStyle={{
                paddingTop: 16,
                paddingRight: 14,
                paddingBottom: 15,
                paddingLeft: 58,
                fontSize: 16,
                width: "100%",
                zIndex: 1,
                height: 40,
                backgroundColor: "#F3F6F9",
              }}
              country={"gh"}
              countryCodeEditable={false}
              enableSearch={true}
              value={another_phone_number}
              inputProps={{
                name: "another_phone_number",
                required: true,
                autoFocus: false,
              }}
              onChange={(value, countryObj, e, formattedValue) =>
                handleMobileNumberInput(value, countryObj, e, formattedValue)
              }
            />
          </div>
          <div className="col-sm-2">
            <button
              type="button"
              onClick={handleAccountInfo}
              className="btn btn-success btn-block"
            >
              Search
            </button>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </div>

          {isNameFound && (
            <>
              <label
                htmlFor="anotherPhoneNumberFullname"
                className="col-sm-5 col-form-label"
              >
                Full Name (From Telco)<span>&nbsp;&nbsp;*</span>
              </label>
              <div className="col-sm-7">
                <input
                  type="text"
                  name="anotherPhoneNumberFullname"
                  id="anotherPhoneNumberFullname"
                  style={{
                    height: "40px",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                  }}
                  required
                  disabled
                  autoComplete="off"
                  value={anotherPhoneNumberFullname}
                  onChange={(e) =>
                    setAnotherPhoneNumberFullname(e.target.value)
                  }
                  className="form-control"
                />
                <h4 className="alert alert-success" role="alert">
                  Please confirm the name above.
                </h4>
              </div>
              <label htmlFor="payment_year" className="col-sm-5 col-form-label">
                Payment Year<span>&nbsp;&nbsp;*</span>
              </label>
              <div className="col-sm-7">
                <input
                  type="text"
                  name="payment_year"
                  id="payment_year"
                  style={{
                    height: "40px",
                    textTransform: "uppercase",
                  }}
                  disabled
                  value={payment_year}
                  className="form-control"
                />
              </div>
              <label htmlFor="amount" className="col-sm-5 col-form-label">
                Amount<span>&nbsp;&nbsp;*</span>
              </label>
              <div className="col-sm-7">
                <input
                  type="number"
                  name="amount"
                  id="amount"
                  style={{
                    height: "40px",
                    textTransform: "uppercase",
                  }}
                  placeholder="Amount"
                  required
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  className="form-control"
                />
                <span>An additional fee may apply to this payment</span>
              </div>
            </>
          )}
        </>
      )}
    </>
  );

  let paymentForm;
  if (isLoading) {
    paymentForm = (
      <div className="loader">
        <p>Processing payment. Please wait...</p>
        <Loader />
      </div>
    );
  } else {
    paymentForm = (
      <form>
        <fieldset className="col-sm-12">
          <div className="form-group row">
            <label htmlFor="fullname" className="col-sm-5 col-form-label">
              Full Name
              <span>&nbsp;&nbsp;*</span>
            </label>
            <div className="col-sm-7">
              <input
                type="text"
                name="fullname"
                id="fullname"
                style={{
                  textTransform: "uppercase",
                }}
                value={fullname}
                onChange={(e) => setFullname(e.target.value)}
                disabled
                required
                className="form-control"
              />
            </div>
            <label
              htmlFor="pay_with_another_number"
              className="col-sm-5 col-form-label"
            >
              Pay With Another Number?
              <span>&nbsp;&nbsp;*</span>
            </label>

            <div className="col-sm-3">
              <label htmlFor="mtn_option">
                <input
                  type="checkbox"
                  id="mtn_option"
                  name="pay_with_another_number"
                  checked={pay_with_another_number === "NO"}
                  value={"NO"}
                  onChange={handlePayWithAnotherNumber}
                />
              </label>
              NO
            </div>
            <div className="col-sm-3">
              <label htmlFor="pay_with_another_number">
                <input
                  type="checkbox"
                  id="voda_option"
                  name="pay_with_another_number"
                  checked={pay_with_another_number === "YES"}
                  value={"YES"}
                  onChange={handlePayWithAnotherNumber}
                />
              </label>
              YES
            </div>
            {isMoMo && mobileMoneyPayment}
          </div>
          {isFinalStepOK && (
            <div className="panel-footer">
              <div className="row">
                <div className="col-sm-6">
                  <button
                    type="submit"
                    className="btn btn-success btn-block"
                    onClick={handleOnlinePayment}
                    disabled={!canSubmit}
                  >
                    Submit
                  </button>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <div className="col-sm-6">
                  <button
                    type="button"
                    onClick={handleCancel}
                    className="btn btn-danger btn-block"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
        </fieldset>
      </form>
    );
  }

  const searchMobileNumber = (
    <>
      <div className="wrapper-container">
        <form>
          <fieldset className="col-sm-12">
            <legend>APPLICANT SEARCH</legend>
            <div className="form-group row">
              <label htmlFor="mobile_number" className="col-sm-3">
                Phone Number
                <span>&nbsp;&nbsp;*</span>
              </label>
              <div className="col-sm-5">
                <PhoneInput
                  id="mobile_number"
                  inputStyle={{
                    paddingTop: 16,
                    paddingRight: 14,
                    paddingBottom: 15,
                    paddingLeft: 58,
                    fontSize: 16,
                    width: "100%",
                    zIndex: 1,
                    height: 40,
                    backgroundColor: "#F3F6F9",
                  }}
                  country={"gh"}
                  countryCodeEditable={false}
                  enableSearch={true}
                  enableClickOutside={false}
                  disableDropdown={false}
                  value={mobile_number}
                  inputProps={{
                    name: "mobile_number",
                    required: true,
                    autoFocus: true,
                  }}
                  disabled={findMember && isMakePayment}
                  onChange={(value, countryObj, e, formattedValue) =>
                    handleMobileNumberInput(
                      value,
                      countryObj,
                      e,
                      formattedValue
                    )
                  }
                  // onBlur={handlePFMembership}
                />
              </div>
              <div className="col-sm-2">
                <button
                  type="button"
                  onClick={handleSearchMember}
                  disabled={findMember && isMakePayment}
                  className="btn btn-success btn-block"
                >
                  Search
                </button>
                &nbsp;&nbsp;&nbsp;&nbsp;
              </div>
              <div className="col-sm-2">
                <button
                  type="button"
                  onClick={handleExit}
                  className="btn btn-danger btn-block"
                >
                  Exit
                </button>
              </div>
            </div>
            <hr />
          </fieldset>

          <fieldset className="col-sm-12">
            {isMakePayment && (
              <>
                <legend>DUES PAYMENT</legend>
                {paymentForm}
              </>
            )}
          </fieldset>
        </form>
      </div>
    </>
  );

  return (
    <>
      <Toaster toastOptions={{ position: "top-center" }} />
      <section className="content-header">
        <h1>
          <i className="fas fa-bank"></i> Admission Fees
        </h1>
      </section>
      <section className="content">
        <div className="box">
          <div className="box-body">
            <div className="panel panel-default panel-br-4">
              <div className="panel-heading">
                <div className="row">
                  <div className="col-sm-12">
                    <h4 className="panel-title">
                      <span></span>
                    </h4>
                  </div>
                </div>
              </div>
              <div className="panel-body">
                <div className="payment-container">
                  {searchMobileNumber}
                  {findMember && memberLedger}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AdmissionFees;
